import { Box, Skeleton } from '@atgfr8/atg-ui-tailwind';
import { For } from 'solid-js';

export const PDFPageSkeleton = (props: { count?: number }) => {
  return (
    <Box class="flex flex-row flex-wrap justify-start gap-4 p-4">
      <For each={Array.from({ length: props.count ?? 3 })}>
        {() => (
          <Skeleton
            variant="rectangular"
            width={260}
            height={320}
            class="rounded"
          />
        )}
      </For>
    </Box>
  );
};
